import { useSelector } from 'react-redux';

interface LoggedInUser {
  _id: string;
  guest: boolean;
  roles: string[];
  forename: string;
  surname: string;
  username: string;
  photoUrl: string;
  pharmacies?: string[];
}

export default function useLoggedInUser(): LoggedInUser | null {
  const user = useSelector(({ auth }: { auth: { user: LoggedInUser } }) => auth.user);

  if (user.guest) {
    return null;
  }

  return user;
}
